module.exports = __webpack_public_path__ + "static/media/add student skills.e5fc8079.svg";